import {
  ConnectionTypeEnum,
  CreateStrategyAssetStepEnum,
  StrategyAssetCategoryTypeEnum,
} from '../../../constants/enums';
import { CreateStrategyAssetCategory } from '../../NewStrategy/types';

export const getCreateStrategyAssetStep = (
  connectionType: ConnectionTypeEnum,
  assetCategorySelection?: CreateStrategyAssetCategory
): {
  step: CreateStrategyAssetStepEnum;
  needLoading: boolean;
} => {
  let step = CreateStrategyAssetStepEnum.INITIAL;
  let needLoading = false;
  if (
    connectionType === ConnectionTypeEnum.WALLET &&
    assetCategorySelection?.createNewCategory
  ) {
    step = CreateStrategyAssetStepEnum.WALLET_CONNECT;
    needLoading = true;
  } else if (connectionType === ConnectionTypeEnum.WALLET) {
    step = CreateStrategyAssetStepEnum.WALLET_ASSETS;
  } else if (
    connectionType === ConnectionTypeEnum.BANK &&
    assetCategorySelection?.createNewCategory
  ) {
    step = CreateStrategyAssetStepEnum.BANK_CONNECT;
  } else if (connectionType === ConnectionTypeEnum.BANK) {
    step = CreateStrategyAssetStepEnum.BANK_ASSETS;
  } else if (
    connectionType === ConnectionTypeEnum.MANUAL &&
    assetCategorySelection?.key === 'ESTATE'
  ) {
    step = CreateStrategyAssetStepEnum.PROPERTY;
  } else if (
    connectionType === ConnectionTypeEnum.MANUAL &&
    assetCategorySelection?.key === 'NFT'
  ) {
    step = CreateStrategyAssetStepEnum.NFT;
  } else if (
    connectionType === ConnectionTypeEnum.MANUAL &&
    assetCategorySelection?.type === StrategyAssetCategoryTypeEnum.SYSTEM
  ) {
    step = CreateStrategyAssetStepEnum.FINANCIAL;
  } else if (
    connectionType === ConnectionTypeEnum.MANUAL &&
    assetCategorySelection?.type === StrategyAssetCategoryTypeEnum.USER &&
    assetCategorySelection?.id
  ) {
    step = CreateStrategyAssetStepEnum.CUSTOM_ASSET;
  } else if (
    connectionType === ConnectionTypeEnum.MANUAL &&
    assetCategorySelection?.type === StrategyAssetCategoryTypeEnum.USER &&
    !assetCategorySelection?.id
  ) {
    step = CreateStrategyAssetStepEnum.CUSTOM_CATEGORY;
  }

  return { step, needLoading };
};
